module.exports = __webpack_public_path__ + "img/cable-sentosa.82e25d3c.svg";